import { Image as ImageApi, ResponseVehicle } from "../types/api";
import { Language } from "../types/language";

export const changeCursor =
  (cursorType: string) => (e: {target: {getStage: () => any}}) => {
    const stage = e.target.getStage();

    if (stage && stage.container()) {
      stage.container().style.cursor = cursorType;
    }
  };

export const extractVisualImage = (images: ImageApi[]) : ImageApi[] | null => {
  const visualImages : ImageApi[] = images.filter((image) => image.label == 'SlideSideLeft');
  return visualImages.length ? visualImages : null;
}

export const checkImageExist = async (vehicle: ResponseVehicle) => {
  let exist : boolean | null = null;

  if(vehicle.images) {
    const visualImage = extractVisualImage(vehicle.images);

    if(visualImage && visualImage.length > 0) {
      exist = await checkImage(visualImage[0].url as string) as boolean;
    }
  }

  return exist;
}

export const checkImage = (url : string) => {
  
  return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = url;
  });
}

export const formatNumber = (value: number, lang: Language): string => {
  let locale = lang == 'en' ? 'en-US' : 'fr-FR';

  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: value % 1 !== 0 ? 2 : 0,
    maximumFractionDigits: 2
  }).format(value);
};